import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { OrgConfig } from '../../types/orgConfig';

interface Location {
  id: string;
  name: string;
  address?: string;
}

interface AppState {
  isLoading: boolean;
  currentLocation: Location | null;
  config: OrgConfig | null;
  selectedLanguage: string;
  primaryLanguage: string | null;
}

const initialState: AppState = {
  isLoading: false,
  currentLocation: null,
  config: null,
  selectedLanguage: 'en',
  primaryLanguage: null,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setCurrentLocation: (state, action: PayloadAction<Location | null>) => {
      state.currentLocation = action.payload;
    },
    setConfig: (state, action: PayloadAction<OrgConfig | null>) => {
      state.config = action.payload;
      if (state.primaryLanguage === null && action.payload?.language) {
        state.primaryLanguage = action.payload.language;
      }
    },
    setSelectedLanguage: (state, action: PayloadAction<string>) => {
      state.selectedLanguage = action.payload;
    },
    resetPrimaryLanguage: (state) => {
      state.primaryLanguage = null;
    },
  },
});

export const { setLoading, setCurrentLocation, setConfig, setSelectedLanguage, resetPrimaryLanguage } = appSlice.actions;
export default appSlice.reducer;